import React, {PureComponent} from 'react';
import PropTypes, {shape} from 'prop-types';
import cx from 'classnames';
import {productButtonStates, serverStatusTypes} from '../../../constants';

import styles from './RecentlyPlayed.pcss';

import GameBox from '../../game-box/GameBox';
import RecentlyPlayedButton from './recently-played-button/RecentlyPlayedButton';

class RecentlyPlayed extends PureComponent {
    static propTypes = {
        background: PropTypes.string,
        logo: PropTypes.string,
        percent: PropTypes.number,
        buttonProps: shape({
            isButtonDisabled: PropTypes.bool,
            isProductUnsupported: PropTypes.bool,
            serverStatus: PropTypes.string,
            productState: PropTypes.string
        }).isRequired,
        buttonActions: PropTypes.object.isRequired,
        gameKey: PropTypes.string
    };

    render() {
        const {background, logo, percent, buttonActions, buttonProps, gameKey} = this.props;
        const {isButtonDisabled, isProductUnsupported, serverStatus, productState} = buttonProps;

        const isRunning = productState === productButtonStates.RUNNING;

        const isDisabled =
            isRunning ||
            isProductUnsupported ||
            productState === productButtonStates.WAITING ||
            (productState === productButtonStates.LAUNCH &&
                serverStatus === serverStatusTypes.OFFLINE) ||
            (productState === productButtonStates.LAUNCH && isButtonDisabled);

        const wrapperClasses = cx(styles.wrapper, {
            [styles.running]: isRunning
        });

        return (
            <li className={wrapperClasses} key={gameKey}>
                <GameBox
                    hasCustomSize
                    className={styles.gamebox}
                    percent={isDisabled ? 0 : percent}
                    background={background}
                    logo={logo}
                />
                <span className={styles.buttonWrapper}>
                    <RecentlyPlayedButton
                        {...buttonActions}
                        {...buttonProps}
                        hasDisabledClass={isDisabled}
                    />
                </span>
            </li>
        );
    }
}

export default RecentlyPlayed;
